<template>
  <container style="max-width: 900px">
    <v-card>
      <v-app-bar flat>
        <v-toolbar-title class="font-weight-medium">
          Preço dos Produtos
        </v-toolbar-title>
      </v-app-bar>
      <v-card-text>
        <v-text-field
          v-model="barcode"
          placeholder="Buscar produto pelo código de barras"
          prepend-inner-icon="mdi-magnify"
          @keydown.enter="fetchProduct"
          :loading="fetching"
          clearable
          @click:clear="clearProduct"
        />
      </v-card-text>
      <empty-state :when="found_product.id == null" message="Pesquise um produto pelo código de barras">
        <v-card-text>
          <v-card dark outlined color="primary">
            <v-img
              :src="found_product.photo_url"
              v-if="$vuetify.breakpoint.xs"
              height="150"
            >
              <template v-slot:placeholder>
                <v-overlay absolute>
                  <v-icon>mdi-image-off</v-icon>
                </v-overlay>
              </template>
            </v-img>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">{{
                  foundProductName
                }}</v-card-title>
                <v-card-subtitle>
                  <div
                    v-for="feature in found_product.features"
                    :key="feature.id"
                    v-text="`${feature.name}: ${feature.pivot.value}`"
                  ></div>
                </v-card-subtitle>
              </div>

              <v-avatar
                class="ma-3"
                size="150"
                rounded
                v-if="$vuetify.breakpoint.smAndUp"
              >
                <v-img :src="found_product.photo_url">
                  <template v-slot:placeholder>
                    <v-overlay absolute>
                      <v-icon>mdi-image-off</v-icon>
                    </v-overlay>
                  </template>
                </v-img>
              </v-avatar>
            </div>
          </v-card>
        </v-card-text>
        <v-card-text>
          <v-card-title class="mx-0 px-0 py-0">Preços</v-card-title>
          <v-divider class="pb-5" />
          <v-row class="font-weight-bold">
            <v-col>Marketplace</v-col>
            <v-col>Preço</v-col>
          </v-row>
          <v-row v-for="price in found_product.prices" :key="price.id"> 
            <v-col>
              <v-chip :href="price.ad_url" target="_blank">
                <v-avatar size="20" class="mr-2" color="grey" left>
                  <v-img v-if="price.store.country" :src="price.store.country.flag_image_url">
                  </v-img>
                </v-avatar>
                {{ price.store.name }}
              </v-chip>    
            </v-col>
            <v-col>
              {{ formatMoney(price.price, price.currency_code) }}
            </v-col>
          </v-row>
        </v-card-text>
      </empty-state>
    </v-card>
  </container>  
</template>

<script>
import money_tool from "@/tools/money";
import EmptyState from "@/components/EmptyState";
import { showPricesByEan } from "@/services/products";

export default {
  components: { EmptyState },
  data: () => ({
    barcode: null,
    fetching: false,
    found_product: {
      id: null,
      brand: null,
      local_category: {
        id: "",
        name: ""
      },
      photo_url: ""
    }
  }),
  methods: {
    formatMoney(price, currency_code) {
      return money_tool.format(price, currency_code)
    },
    clearProduct() {
      this.found_product = {
        id: null,
        brand: null,
        local_category: {
          id: "",
          name: ""
        },
        photo_url: ""
      };
    },
    async fetchProduct() {
      if (!this.barcode) return;

      this.fetching = true;
      try {
        const product = await showPricesByEan(this.barcode);
        this.found_product = {
          ...product,
          photo_url: product.product_photos
            ? product.product_photos[0]?.url
            : "",
          features: product.features ? product.features.slice(0, 5) : []
        };
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: `Falha ao consultar por código de barras`,
          color: "red"
        });
      } finally {
        this.fetching = false;
      }
    }
  },
  computed: {
    foundProductName: function() {
      const name = [
        this.found_product.local_category?.name,
        this.found_product.brand?.name
      ].join(" ");

      if (name.length > 59) return name.substr(0, 56) + "...";

      return name;
    }
  }
}
</script>